module.exports = __webpack_public_path__ + "img/event-img.a260ac3f.png";